export default __webpack_public_path__ + "static/media/trident-1.0e3ed270.jpg";